import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { CmxSpinnerService } from './cmx-spinner.service';
import { concatMap, timeout, catchError, delay, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerParam } from './cmx-spinner.service';

@Component({
  selector: 'cmx-spinner',
  templateUrl: './cmx-spinner.component.html',
  styleUrls: ['./cmx-spinner.component.scss'],
})
export class CmxSpinnerComponent implements OnInit, OnDestroy {
  @Input()
  public size = '10';

  @Input()
  descriptionShow;

  @Input()
  spinnerName = 'layout';

  @Input()
  labelPosition = 'bottom';

  private _ngDestroyed;

  _labels: string[] = [
    'views.spinner.title.plese_wait',
    'views.spinner.title.taking_longer',
    'views.spinner.title.error_occur',
  ];

  public label: string;
  public params: SpinnerParam;
  constructor(private loadingSpinner: CmxSpinnerService, private t: TranslateService) {
    this._ngDestroyed = new Subject();
  }

  ngOnDestroy() {
    if (this.loadingSpinner && this.loadingSpinner.hasOwnProperty('hide')) {
      this.loadingSpinner.hide();
    }
    this._ngDestroyed.next();
    this._ngDestroyed.complete();
  }

  ngOnInit() {
    this.loadingSpinner
      .getSpinner()
      .pipe(takeUntil(this._ngDestroyed))
      .subscribe((params: SpinnerParam) => {
        this.params = params;
        if (!params.state) {
          return;
        }

        of(1, 10000, 60000)
          .pipe(
            concatMap((duration, index) =>
              this.makeRequest(duration).pipe(
                timeout(duration),
                catchError(error => of(this.t.instant(this._labels[index]))),
              ),
            ),
          )
          .subscribe(val => (this.label = val));
      });
  }

  makeRequest(timeToDelay) {
    return of('Steper Complete!').pipe(delay(timeToDelay));
  }

  getSize(): string {
    return this.size;
  }
}
